import { apiFetch } from "@/utils/api";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export async function listBudgets() {
  const res = await apiFetch(`${API}/budgets`);
  return res.ok ? res.json() : [];
}
export async function getBudget(id) {
  const res = await apiFetch(`${API}/budgets/${id}`);
  if (!res.ok) throw new Error("No se pudo cargar el presupuesto");
  return res.json();
}
export async function createBudget(payload) {
  const res = await apiFetch(`${API}/budgets`, { method: "POST", body: JSON.stringify(payload) });
  return res.json();
}
export async function updateBudget(id, payload) {
  const res = await apiFetch(`${API}/budgets/${id}`, { method: "PUT", body: JSON.stringify(payload) });
  return res.json();
}
export async function deleteBudget(id) {
  return apiFetch(`${API}/budgets/${id}`, { method: "DELETE" });
}
export async function duplicateBudget(id) {
  const res = await apiFetch(`${API}/budgets/${id}/duplicate`, { method: "POST" });
  return res.json();
}
export async function computeBudget(payload) {
  const res = await apiFetch(`${API}/budgets/compute`, { method: "POST", body: JSON.stringify(payload) });
  return res.json();
}
export async function prefillSuggestions() {
  const res = await apiFetch(`${API}/budgets/prefill-suggestions`);
  return res.ok ? res.json() : { lines: [] };
}
// Asistente IA de presupuesto (ítem 3.5): borrador determinista de partidas
// desde el histórico. Con consent=false las partidas llegan igual, sin `why`.
export async function assistantDraft(year) {
  const res = await apiFetch(`${API}/budgets/assistant-draft?year=${encodeURIComponent(year)}`);
  if (!res.ok) throw new Error("No se pudo generar el borrador del asistente");
  return res.json();
}
export async function getCurrentBalance() {
  const res = await apiFetch(`${API}/budgets/current-balance`);
  return res.ok ? (await res.json()).balance : 0;
}
export async function getActuals(startMonth, endMonth) {
  const res = await apiFetch(`${API}/budgets/actuals?start_month=${startMonth}&end_month=${endMonth}`);
  if (!res.ok) throw new Error("No se pudo cargar el histórico real");
  return res.json();
}
export async function getActualsMovements(startMonth, endMonth, kind, category) {
  const p = new URLSearchParams({ start_month: startMonth, end_month: endMonth, kind, category });
  const res = await apiFetch(`${API}/budgets/actuals/movements?${p}`);
  if (!res.ok) throw new Error("No se pudieron cargar los movimientos");
  return res.json();
}
